import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { CREW_NUDGE_COPY, CREW_NUDGE_TOOLTIP_COPY, CREW_NUDGE_TOOLTIP_KEY } from "../copy.js";

function readTooltipSeen() {
  try {
    return Boolean(localStorage.getItem(CREW_NUDGE_TOOLTIP_KEY));
  } catch {
    return true;
  }
}

function markTooltipSeen() {
  try {
    localStorage.setItem(CREW_NUDGE_TOOLTIP_KEY, "1");
  } catch {
    /* private browsing / quota */
  }
}

export default function CrewNudgeLine({ show, showTooltip = false, tooltipContext = "main-feed" }) {
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    if (!show || !showTooltip) return;
    if (!readTooltipSeen()) {
      setShowTip(true);
      markTooltipSeen();
    }
  }, [show, showTooltip]);

  if (!show) return null;

  function dismissTip() {
    setShowTip(false);
    markTooltipSeen();
  }

  const dismissLabel = "Dismiss Favorite Dances crew card tip";

  return (
    <div className="mt-1.5 min-w-0" data-testid="crew-nudge-line">
      <p className="font-ui text-[12px] font-semibold leading-snug text-plum break-words">
        {CREW_NUDGE_COPY}
      </p>
      {showTip && (
        <div className="mt-1.5 flex items-start gap-2 rounded-md2 bg-cream/80 px-2.5 py-2">
          <p className="min-w-0 flex-1 font-ui text-[12px] font-medium leading-snug text-ink/75 break-words text-pretty">
            {CREW_NUDGE_TOOLTIP_COPY}
          </p>
          <button
            type="button"
            onClick={dismissTip}
            className="shrink-0 rounded-md2 p-1.5 min-w-[32px] min-h-[32px] flex items-center justify-center text-ink/60 hover:bg-white/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2"
            aria-label={dismissLabel}
            data-testid="crew-nudge-tip-dismiss"
          >
            <X className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
          </button>
        </div>
      )}
    </div>
  );
}
